import {
  fontSmall,
  inputHoverColors
} from '../../../views/action-flow/components/library/css'
import styled from 'styled-components'

// WIP here

export const Textarea = styled.textarea<{valid: boolean}>`
  height: 160px;
  min-height: 30px;
  border: none;
  font-family: 'atomic___RobotoMono', monospace;
  color: ${p => (p.valid ? p.theme.black : p.theme.red)};
  display: block;
  background: none;
  resize: vertical;
  padding: 12px;
  overflow: auto;
  white-space: pre;
  ${fontSmall}
`

export const Label = styled.label`
  color: ${props => props.theme.colors.grey11};
  display: flex;
  align-items: center;
  height: 30px;
  padding: 8px 12px;
  ${fontSmall}
`

export const Wrapper = styled.div<{hasLabel: boolean}>`
  display: block;
  border-radius: 4px;
  position: relative;
  ${props => props.hasLabel && `textarea { padding-top: 5px; }`}
  ${inputHoverColors}
`
// useful in css rules
export const JSONFieldWrapper = Wrapper
